import * as consentAction from './consent-management-action'

export {
    consentAction,
}



// WEBPACK FOOTER //
// ./src/actions/consent-management/index.js